import { LngLat, LngLatBounds } from 'mapbox-gl';
import { VisitDtoModelType } from '../../store/mst/models';

const getBoundsFromVisits = (unscheduledVisits: VisitDtoModelType[]) => {
  const bounds = new LngLatBounds();

  unscheduledVisits.forEach((visit) => {
    if (!visit.hasLngLat) {
      return;
    }
    const [lng, lat] = [visit.activeLocation.longitude, visit.activeLocation.latitude];

    if (lng && lat) {
      bounds.extend(new LngLat(lng, lat));
    }
  });

  return bounds.isEmpty() ? null : bounds;
};

export default getBoundsFromVisits;
